import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { MfaEnrolmentPage } from '@/features/auth';
import { zSearchText } from '@/shared/lib/search';

export const Route = createFileRoute('/login_/mfa-setup')({
  validateSearch: z.object({ redirect: zSearchText() }),
  component: function MfaSetup() {
    const { redirect } = Route.useSearch();
    return <MfaEnrolmentPage redirect={redirect} />;
  },
});
